import { render, staticRenderFns } from "./CardTaskBlock.vue?vue&type=template&id=61878cc0&scoped=true&"
import script from "./CardTaskBlock.vue?vue&type=script&lang=js&"
export * from "./CardTaskBlock.vue?vue&type=script&lang=js&"
import style0 from "./CardTaskBlock.vue?vue&type=style&index=0&id=61878cc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61878cc0",
  null
  
)

export default component.exports